import React, { useEffect } from "react";
import CommonLayout from "../../components/Layouts/CommonLayout";
import SelectedPhotos from "../../components/UserFlow/FolderView/SelectedPhotos";

const SelectedPhotosPage = () => {
  return <SelectedPhotos />;
};

export default SelectedPhotosPage;
